<template>
<div :class="isApplication ? 'application-modal' : ''">
    <div class="info-modal-overlay"  @click="close()"></div>    
    <div :class="isApplication ? 'application-container info-modal' : 'info-modal'">
        <div class="info-modal-close-section">
            <inline-svg src="/img/icons/close.svg" width="21" height="21" :fill="this.$store.state.nightMode ? 'white' : 'black'" @click="close()"></inline-svg>
        </div>

        <div class="location-city__title">
            Де ви знаходитесь?
        </div>

        <ul class="location-city__list">
            <li v-for="locationCity in locationCities" :key="locationCity.id" class="location-city__item" @click="changeLocationCity(locationCity.id)">
                {{ locationCity.name }}
            </li>
        </ul>

        <div style="padding-bottom: 34px;font-weight: bold;font-size: 1.4rem;padding-left: 14px;padding-right: 14px;" v-html="info" v-if="!isApplication">
                
        </div>
    </div>
</div>
</template>

<script>
import InlineSvg from 'vue-inline-svg';

export default {
    components: {
      InlineSvg
    },
    props: ['locationCities', 'changeLocationCity', 'isApplication', 'applicationType', 'applicationURL'],
    data() {
        return {
        }
    },

    methods: {
        close() {
            this.$emit('close');
        },
    }
}
</script>

<style>
.location-city__title {
    margin-bottom: 12px;

    font-size: 1.2em;
    font-weight: 600;
}

.location-city__list {
    display: flex;
    flex-direction: column;
    align-items: center;

    list-style: none;
    padding: 0;
}

.location-city__item {
    max-width: 250px;
    width: 100%;

    padding: 8px;
    margin-bottom: 6px;
    border: 1px #343434 solid;
    border-radius: 6px;

    cursor: pointer;
    transition: 0.33s all;
    font-weight: 700;
    opacity: 0.75;
}

.location-city__item:hover {
    opacity: 1;
}

.info-modal-overlay {
    width: 100%;
    height: 100%;
    background-color: rgba(70, 70, 70, 0.9);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
}

.info-modal {
    position: fixed;
    width: 90%;
    max-width: 520px;
    background-color: #fff;
    border: 1px solid #eee;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 8px;
    z-index: 101;
}

@media only screen and (max-width: 767px) {
    .application-modal .info-modal-overlay {
        display: none;
    }
    .application-modal .mob-nav-overlay {
        display: none;
    }

    .dark .application-container {
        box-shadow: 5px 0 15px rgba(255,255,255,0.3);
    }

    .application-container {
        z-index: 101;
        position: fixed;
        top: unset;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);

        width: 100%;
        max-width: 520px;

        padding: 10px 15px;
        border: 0px;

        background-color: #fff;
        border-radius: 0;
        box-shadow: 5px 0 15px rgba(0,0,0,0.3);
    }

    .application-modal .info-modal-close-section {
        position: absolute;
        right: 10px;
        top: 10px;
        padding: 0;

        cursor: pointer;
    }
}

.info-modal-close-section {
    display: flex;
    justify-content: flex-end;
    padding: 14px;
}

.info-modal-title {
    text-align: left;
    padding-left: 14px;
    font-size: 1.4rem;
    font-weight: 700;
}
</style>